import { render, staticRenderFns } from "./ThePersonalAddressesNew.vue?vue&type=template&id=1f70e662&"
import script from "./ThePersonalAddressesNew.vue?vue&type=script&lang=js&"
export * from "./ThePersonalAddressesNew.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalAddressesNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports